module.exports = __webpack_public_path__ + "img/RECREATION_MATCHPICTURE.213652ae.png";